// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ClaimStatusCriteria from './claim-status-criteria';
import Criteria from '../../state/criteria';
import CriteriaFooter from './criteria-footer';
import CriteriaSectionOne from './criteria-section-one';
import CriteriaSectionTwo from './criteria-section-two';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import DealerCriteria from '../../../shared/components/dealer-criteria';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {isClaimCreatedRequired} from '../../report-services/services';

const ReportCriteria = props =>
    <div className='report-criteria'>
        <div className='criteria'>
            <DealerCriteria
                onDealerSelect={props.onDealerSelect}
                onSelectAllDealers={props.onSelectAllDealers}
                selectedAccounts={props.selectedAccounts}
                selectedDealers={props.selectedDealers}
            />
            <CriteriaSectionOne
                criteria={props.criteria}
                onCriteriaInputChange={props.onCriteriaInputChange}
            />
            <CriteriaSectionTwo
                criteria={props.criteria}
                isClaimCreatedRequired={isClaimCreatedRequired(props.selectedStatuses, props.criteria)}
                onCriteriaDateChange={props.onCriteriaDateChange}
                onCriteriaInputChange={props.onCriteriaInputChange}
            />
            <ClaimStatusCriteria
                allowedStatuses={props.allowedStatuses}
                onAllClaimStatusesSelect={props.onAllClaimStatusesSelect}
                onClaimStatusSelect={props.onClaimStatusSelect}
                selectedStatuses={props.selectedStatuses}
            />
        </div>
        <CriteriaFooter
            canRunReport={props.canRunReport}
            onCriteriaReset={props.onCriteriaReset}
            onRunReport={props.onRunReport}
        />
    </div>;

ReportCriteria.displayName = 'ReportCriteria';
ReportCriteria.propTypes = {
    allowedStatuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    canRunReport: PropTypes.bool.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    onAllClaimStatusesSelect: PropTypes.func.isRequired,
    onClaimStatusSelect: PropTypes.func.isRequired,
    onCriteriaDateChange: PropTypes.func.isRequired,
    onCriteriaInputChange: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onRunReport: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedStatuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default ReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/components/report-criteria/index.js